

import { useMutation } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type CreateSubscriptionPaymentProofUploadInput = {
  storeId: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
};

type CreateSubscriptionPaymentProofUploadResponse = {
  uploadUrl: string;
  objectKey: string;
};

export function useCreateSubscriptionPaymentProofUploadMutation() {
  const mutation = useMutation({
    mutationFn: (input: CreateSubscriptionPaymentProofUploadInput) =>
      apiJsonClient<CreateSubscriptionPaymentProofUploadResponse>(
        endpoints.admin.subscriptionPaymentProofUploads,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(input),
        },
      ),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
